<template>
  <v-data-table
    :headers="headers"
    :items="turmas"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >

    <template v-slot:top>
      <v-toolbar flat color="white">
         <v-progress-circular
                        :size="50"
                        color="green"
                        indeterminate
                         v-if="isLoading"
                      ></v-progress-circular>
        <v-btn
          to="/menu-pauta-anual"
          class="mx-2"
          fab
          dark
          color="primary"
        >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>

        <v-divider class="mx-8" inset vertical></v-divider>
        <v-toolbar-title>
          Turma(s) da
          <span v-if="idclasse === 1">10ª classe</span>
          <span v-if="idclasse === 2">11ª classe</span>
          <span v-if="idclasse === 3">12ª classe</span>
          <span v-if="idclasse === 4">13ª classe</span>
        </v-toolbar-title>
        <v-divider class="mx-8" inset vertical></v-divider>
             <span>Selecionado : <strong style="font-size:22px;">{{$store.state.novadescricaoSelecionado}}</strong></span>
        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
       
      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
        <v-icon  class="mr-2" @click=" criarPdf(item) "  style="color:green">print</v-icon>

    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
</template>
<script>
import axios from '../../plugins/axios'
// import jsreport from 'jsreport-browser-client-dist/jsreport'
const ls = require('local-storage')
const help = require('../../../Helpers/Helpers')
import Swal from 'sweetalert2'
export default {
  data: () => ({
    relatorio: [],
    readImage: `http://eftsl.softlineangola.com/readfile/`,
    option: { 'format': 'A3',
      'orientation': 'landscape',
      paginationOffset: 2,
      'header': {
        'height': '10mm',
        'contents': '' },
      'footer': {
        'height': '5mm'
      } },
    url: ``,
    alunosTurma: [],
    sala: '',
    search: '',
    quant: 0,
    cursos: [],
    html: ``,
    disciplinas: [],
    notas: [],
    isLoading: false,
    turmas: [],
    headers: [
      {
        text: 'descricao',
        align: 'left',
        sortable: false,
        value: 'turmadescricao'
      },
      { text: 'Periodo', value: 'periodo' },
      { text: 'Curso', value: 'curso' },
      { text: 'Numero de Alunos', value: 'quantalunos' },
      { text: 'Modificado', value: 'data_2' },
      { text: 'Acção', value: 'action', sortable: false }
    ],

    editedIndex: -1,
    editedItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    },
    defaultItem: {
      idCurso: 0,
      idAno_Academico: 0,
      descricao: '',
      autor: '',
      periodo: '',
      idinstituicao: ''
    }
  }),

  computed: {
    idclasse () {
      return this.$store.state.idclasse
    },
    instituicaodescricao () { return ls.get('instituicaodescricao') },

    instituicaoId () { return ls.get('i_id') }
  },

  watch: { },

  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.initializeturmasAll()
   this.carregarConfiguracoesReports()
   this.carregarRelatorio()
  },

  methods: {
    
    async carregarRelatorio() {
            try {
                this.relatorio = await axios.get('/obterRelatorioByDescricao/pa').then(res => res.data)
              if(!this.relatorio) Swal.fire({ icon: 'warning', title: '', text: 'Pauta Anual não configurada' })
              } catch (error) {
                Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o relatório' })
            }
    }, 
    redClasse(resultado) {
               return (resultado !== 'Transita' ? 'NaoTransita' : resultado)
   },
   descricaoEscola () {  return (this.instituicaoId === 1)?'INSTITUTO TÉCNICO DE SAÚDE DE LUANDA':this.instituicaodescricao.toUpperCase() },

    getClasseDescricao (idclasse){

         switch (idclasse) {
              case 1:
                   return '10ª Classe'
               case 2:
                     return '11ª Classe'
               case 3:
                    return '12ª Classe'
               case 4:
                     return '13ª Classe'
         
              default:
                   break;
         }


    },

    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmas = await axios
          .get('/turmaFindAll-Anolectivo/' + this.$store.state.anolectivoSelecionado + '/' + this.$store.state.idclasse)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar as turmas' })
      }
    },
  
    zebraPauta (i) {
      if (i % 2) {
        return 'zebr'
      } else {
        return ''
      }
    },
    async  pautasgerarpdf (options) {
      this.isLoading = true
      try {
        await axios({
          method: 'post',
          url: ls.get('urlReport') + 'writefile',
          data: {
            html: this.html,
            file_name: ls.get('idPessoa'),
            option: options
          }
        }).then(function (response) {
        })
        // Imprimir PDF
        this.isLoading = false
        this.frame()
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao gerar o PDF' })
        this.isLoading = false
      }
    },
    frame () {
      this.isLoading = false
      this.url = ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf'
      let frame = `<html> +
      <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
      <body>
      <iframe target="_blank" type="application/pdf" src="` + this.url + `"></iframe> 
      </body></html>`
      let a = window.open('about:blank', '_blank', '', true)
      a.document.write(frame)
      a.document.close()
    },
    comporHtmlPauta4 (dados, notas) {
      try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },

comporHtmlPauta6 (dados, notas) {
  try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },

    comporHtmlPauta8 (dados, notas) {
      try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },
    comporHtmlPauta9 (dados, notas) {
      try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                        iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                        iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                        iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                        iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                        iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },
    comporHtmlPauta10 (dados, notas) {
      try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                        iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                        iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                        iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                        iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                        iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                        iter1 = iter1.replace(/{{md_9}}/g, this.isNull(element.md_9)) 
                        iter1 = iter1.replace(/{{m2_9}}/g, this.isNull(element.m2_9)) 
                        iter1 = iter1.replace(/{{m3_9}}/g, this.isNull(element.m3_9)) 
                        iter1 = iter1.replace(/{{mf_9}}/g, this.isNull(element.mf_9)) 
                        iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },
    comporHtmlPauta11 (dados, notas) {
      console.log(notas);
      
      try {        
                        let disciplinasiter = ''
                        let avaliacoesiter = ''
                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                        iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                        iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                        iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                        iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                        iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                        iter1 = iter1.replace(/{{md_9}}/g, this.isNull(element.md_9)) 
                        iter1 = iter1.replace(/{{m2_9}}/g, this.isNull(element.m2_9)) 
                        iter1 = iter1.replace(/{{m3_9}}/g, this.isNull(element.m3_9)) 
                        iter1 = iter1.replace(/{{mf_9}}/g, this.isNull(element.mf_9)) 
                        iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))

                        iter1 = iter1.replace(/{{md_10}}/g, this.isNull(element.md_10)) 
                        iter1 = iter1.replace(/{{m2_10}}/g, this.isNull(element.m2_10)) 
                        iter1 = iter1.replace(/{{m3_10}}/g, this.isNull(element.m3_10)) 
                        iter1 = iter1.replace(/{{mf_10}}/g, this.isNull(element.mf_10)) 
                        iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },
    comporHtmlPauta12 (dados, notas) {
      try {
        
         let disciplinasiter = ''
                         let avaliacoesiter = ''

                         let iteralunos = ``
                         this.html = this.relatorio[0].documento
                         this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                         this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                         this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                         this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                         this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                         this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                         this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                         this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                         this.html = this.html.replace(/{{percentagemtabela}}/g, 100)
                         this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                         for (let indice = 0; indice < dados.length; indice++) {
                         const element = dados[indice];
                         iteralunos += this.relatorio[0].documentoiteracao4
                         iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                         iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                         iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                         iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                         iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                         avaliacoesiter += this.relatorio[0].documentoiteracao2
                         disciplinasiter += this.relatorio[0].documentoiteracao1        
                         disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                         }
                         let iter1 = ''
                         for (let j = 0; j < notas.length; j++) {
                         const element = notas[j];
                         iter1 += this.relatorio[0].documentoiteracao3
                         iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                         iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                         iter1 = iter1.replace(/{{indice}}/g, j+1) 
                         iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                         iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                         iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                         iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                         iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                         iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                         iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                         iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                         iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                         iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                         iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                         iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                         iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                         iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                         iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                         iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                         iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                         iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                         iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                         iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                         iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                         iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                         iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                         iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                         iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                         iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                         iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                         iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                         iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                         iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                         iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                         iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                         iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                         
                         iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                         iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                         iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                         iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                         iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                         iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                         iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                         iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                         iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                         iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                         iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                         iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                         iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                         iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                         iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                         iter1 = iter1.replace(/{{md_9}}/g, this.isNull(element.md_9)) 
                         iter1 = iter1.replace(/{{m2_9}}/g, this.isNull(element.m2_9)) 
                         iter1 = iter1.replace(/{{m3_9}}/g, this.isNull(element.m3_9)) 
                         iter1 = iter1.replace(/{{mf_9}}/g, this.isNull(element.mf_9)) 
                         iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))

                         iter1 = iter1.replace(/{{md_10}}/g, this.isNull(element.md_10)) 
                         iter1 = iter1.replace(/{{m2_10}}/g, this.isNull(element.m2_10)) 
                         iter1 = iter1.replace(/{{m3_10}}/g, this.isNull(element.m3_10)) 
                         iter1 = iter1.replace(/{{mf_10}}/g, this.isNull(element.mf_10)) 
                         iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))

                         iter1 = iter1.replace(/{{md_11}}/g, this.isNull(element.md_11)) 
                         iter1 = iter1.replace(/{{m2_11}}/g, this.isNull(element.m2_11)) 
                         iter1 = iter1.replace(/{{m3_11}}/g, this.isNull(element.m3_11)) 
                         iter1 = iter1.replace(/{{mf_11}}/g, this.isNull(element.mf_11)) 
                         iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))
                         }
                         this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                         this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                         this.html = this.html.replace(/{{dados}}/g, iter1)
      let options = { 'format': 'A3',
        'orientation': 'landscape',
        'border': {
                    'right': '10mm',
                    'left': '10mm' 
              },
        'header': {
          'height': '14mm' },
        'footer': {
          'height': '5mm'
        } }
        this.pautasgerarpdf(options)
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
      }

    },


comporHtmlPauta13 (dados, notas) {
  try {        
        let disciplinasiter = ''
                        let avaliacoesiter = ''

                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 80)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 90)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                        iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                        iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                        iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                        iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                        iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                        iter1 = iter1.replace(/{{md_9}}/g, this.isNull(element.md_9)) 
                        iter1 = iter1.replace(/{{m2_9}}/g, this.isNull(element.m2_9)) 
                        iter1 = iter1.replace(/{{m3_9}}/g, this.isNull(element.m3_9)) 
                        iter1 = iter1.replace(/{{mf_9}}/g, this.isNull(element.mf_9)) 
                        iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))

                        iter1 = iter1.replace(/{{md_10}}/g, this.isNull(element.md_10)) 
                        iter1 = iter1.replace(/{{m2_10}}/g, this.isNull(element.m2_10)) 
                        iter1 = iter1.replace(/{{m3_10}}/g, this.isNull(element.m3_10)) 
                        iter1 = iter1.replace(/{{mf_10}}/g, this.isNull(element.mf_10)) 
                        iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))

                        iter1 = iter1.replace(/{{md_11}}/g, this.isNull(element.md_11)) 
                        iter1 = iter1.replace(/{{m2_11}}/g, this.isNull(element.m2_11)) 
                        iter1 = iter1.replace(/{{m3_11}}/g, this.isNull(element.m3_11)) 
                        iter1 = iter1.replace(/{{mf_11}}/g, this.isNull(element.mf_11)) 
                        iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))

                        iter1 = iter1.replace(/{{md_12}}/g, this.isNull(element.md_12)) 
                        iter1 = iter1.replace(/{{m2_12}}/g, this.isNull(element.m2_12)) 
                        iter1 = iter1.replace(/{{m3_12}}/g, this.isNull(element.m3_12)) 
                        iter1 = iter1.replace(/{{mf_12}}/g, this.isNull(element.mf_12)) 
                        iter1 = iter1.replace(/{{co_12}}/g, this.isNull(element.co_12))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },







comporHtmlPauta14 (dados, notas) {
  try {        
        let disciplinasiter = ''
                        let avaliacoesiter = ''

                        let iteralunos = ``
                        this.html = this.relatorio[0].documento
                        this.html = this.html.replace(/{{instituicaodescricao}}/g, this.descricaoEscola())
                        this.html = this.html.replace(/{{insignia}}/g, ls.get('insignia'))
                        this.html = this.html.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
                        this.html = this.html.replace(/{{curso}}/g, dados[0].curso)
                        this.html = this.html.replace(/{{turma}}/g, dados[0].descricao)
                        this.html = this.html.replace(/{{classe}}/g, this.getClasseDescricao(this.idclasse))
                        this.html = this.html.replace(/{{periodo}}/g, dados[0].periodo)
                        this.html = this.html.replace(/{{larguracolunanome}}/g, 70)
                        this.html = this.html.replace(/{{percentagemtabela}}/g, 70)
                        this.html = this.html.replace(/{{dataactual}}/g, help.presente_data())

                        for (let indice = 0; indice < dados.length; indice++) {
                        const element = dados[indice];
                        iteralunos += this.relatorio[0].documentoiteracao4
                        iteralunos = iteralunos.replace(/{{m1}}/g, '{{md_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m2}}/g, '{{m2_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{m3}}/g, '{{m3_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{md}}/g, '{{mf_' + indice + '}}')
                        iteralunos = iteralunos.replace(/{{colornota}}/g, '{{co_' + indice + '}}')
                        avaliacoesiter += this.relatorio[0].documentoiteracao2
                        disciplinasiter += this.relatorio[0].documentoiteracao1        
                        disciplinasiter = disciplinasiter.replace(/{{disciplina}}/g, element.disciplina)       
                        }
                        let iter1 = ''
                        for (let j = 0; j < notas.length; j++) {
                        const element = notas[j];
                        iter1 += this.relatorio[0].documentoiteracao3
                        iter1 = iter1.replace(/{{outrascolunas}}/g, iteralunos)
                        iter1 = iter1.replace(/{{zebra}}/g, this.zebraPauta(j)) 
                        iter1 = iter1.replace(/{{indice}}/g, j+1) 
                        iter1 = iter1.replace(/{{nome}}/g, element.nome) 
                        iter1 = iter1.replace(/{{resultado}}/g, this.isNull(element.resultado)) 
                        iter1 = iter1.replace(/#classe/g, this.redClasse(element.resultado))  

                        iter1 = iter1.replace(/{{md_0}}/g, this.isNull(element.md_0)) 
                        iter1 = iter1.replace(/{{m2_0}}/g, this.isNull(element.m2_0)) 
                        iter1 = iter1.replace(/{{m3_0}}/g, this.isNull(element.m3_0)) 
                        iter1 = iter1.replace(/{{mf_0}}/g, this.isNull(element.mf_0)) 
                        iter1 = iter1.replace(/{{co_0}}/g, this.isNull(element.co_0))

                        iter1 = iter1.replace(/{{md_1}}/g, this.isNull(element.md_1)) 
                        iter1 = iter1.replace(/{{m2_1}}/g, this.isNull(element.m2_1)) 
                        iter1 = iter1.replace(/{{m3_1}}/g, this.isNull(element.m3_1)) 
                        iter1 = iter1.replace(/{{mf_1}}/g, this.isNull(element.mf_1)) 
                        iter1 = iter1.replace(/{{co_1}}/g, this.isNull(element.co_1))

                        iter1 = iter1.replace(/{{md_2}}/g, this.isNull(element.md_2)) 
                        iter1 = iter1.replace(/{{m2_2}}/g, this.isNull(element.m2_2)) 
                        iter1 = iter1.replace(/{{m3_2}}/g, this.isNull(element.m3_2)) 
                        iter1 = iter1.replace(/{{mf_2}}/g, this.isNull(element.mf_2)) 
                        iter1 = iter1.replace(/{{co_2}}/g, this.isNull(element.co_2))

                        iter1 = iter1.replace(/{{md_3}}/g, this.isNull(element.md_3)) 
                        iter1 = iter1.replace(/{{m2_3}}/g, this.isNull(element.m2_3)) 
                        iter1 = iter1.replace(/{{m3_3}}/g, this.isNull(element.m3_3)) 
                        iter1 = iter1.replace(/{{mf_3}}/g, this.isNull(element.mf_3)) 
                        iter1 = iter1.replace(/{{co_3}}/g, this.isNull(element.co_3))

                        iter1 = iter1.replace(/{{md_4}}/g, this.isNull(element.md_4)) 
                        iter1 = iter1.replace(/{{m2_4}}/g, this.isNull(element.m2_4)) 
                        iter1 = iter1.replace(/{{m3_4}}/g, this.isNull(element.m3_4)) 
                        iter1 = iter1.replace(/{{mf_4}}/g, this.isNull(element.mf_4)) 
                        iter1 = iter1.replace(/{{co_4}}/g, this.isNull(element.co_4))

                        iter1 = iter1.replace(/{{md_5}}/g, this.isNull(element.md_5)) 
                        iter1 = iter1.replace(/{{m2_5}}/g, this.isNull(element.m2_5)) 
                        iter1 = iter1.replace(/{{m3_5}}/g, this.isNull(element.m3_5)) 
                        iter1 = iter1.replace(/{{mf_5}}/g, this.isNull(element.mf_5))
                        iter1 = iter1.replace(/{{co_5}}/g, this.isNull(element.co_5))
                        
                        iter1 = iter1.replace(/{{md_6}}/g, this.isNull(element.md_6)) 
                        iter1 = iter1.replace(/{{m2_6}}/g, this.isNull(element.m2_6)) 
                        iter1 = iter1.replace(/{{m3_6}}/g, this.isNull(element.m3_6)) 
                        iter1 = iter1.replace(/{{mf_6}}/g, this.isNull(element.mf_6)) 
                        iter1 = iter1.replace(/{{co_6}}/g, this.isNull(element.co_6))

                        iter1 = iter1.replace(/{{md_7}}/g, this.isNull(element.md_7)) 
                        iter1 = iter1.replace(/{{m2_7}}/g, this.isNull(element.m2_7)) 
                        iter1 = iter1.replace(/{{m3_7}}/g, this.isNull(element.m3_7)) 
                        iter1 = iter1.replace(/{{mf_7}}/g, this.isNull(element.mf_7)) 
                        iter1 = iter1.replace(/{{co_7}}/g, this.isNull(element.co_7))

                        iter1 = iter1.replace(/{{md_8}}/g, this.isNull(element.md_8)) 
                        iter1 = iter1.replace(/{{m2_8}}/g, this.isNull(element.m2_8)) 
                        iter1 = iter1.replace(/{{m3_8}}/g, this.isNull(element.m3_8)) 
                        iter1 = iter1.replace(/{{mf_8}}/g, this.isNull(element.mf_8)) 
                        iter1 = iter1.replace(/{{co_8}}/g, this.isNull(element.co_8))

                        iter1 = iter1.replace(/{{md_9}}/g, this.isNull(element.md_9)) 
                        iter1 = iter1.replace(/{{m2_9}}/g, this.isNull(element.m2_9)) 
                        iter1 = iter1.replace(/{{m3_9}}/g, this.isNull(element.m3_9)) 
                        iter1 = iter1.replace(/{{mf_9}}/g, this.isNull(element.mf_9)) 
                        iter1 = iter1.replace(/{{co_9}}/g, this.isNull(element.co_9))

                        iter1 = iter1.replace(/{{md_10}}/g, this.isNull(element.md_10)) 
                        iter1 = iter1.replace(/{{m2_10}}/g, this.isNull(element.m2_10)) 
                        iter1 = iter1.replace(/{{m3_10}}/g, this.isNull(element.m3_10)) 
                        iter1 = iter1.replace(/{{mf_10}}/g, this.isNull(element.mf_10)) 
                        iter1 = iter1.replace(/{{co_10}}/g, this.isNull(element.co_10))

                        iter1 = iter1.replace(/{{md_11}}/g, this.isNull(element.md_11)) 
                        iter1 = iter1.replace(/{{m2_11}}/g, this.isNull(element.m2_11)) 
                        iter1 = iter1.replace(/{{m3_11}}/g, this.isNull(element.m3_11)) 
                        iter1 = iter1.replace(/{{mf_11}}/g, this.isNull(element.mf_11)) 
                        iter1 = iter1.replace(/{{co_11}}/g, this.isNull(element.co_11))

                        iter1 = iter1.replace(/{{md_12}}/g, this.isNull(element.md_12)) 
                        iter1 = iter1.replace(/{{m2_12}}/g, this.isNull(element.m2_12)) 
                        iter1 = iter1.replace(/{{m3_12}}/g, this.isNull(element.m3_12)) 
                        iter1 = iter1.replace(/{{mf_12}}/g, this.isNull(element.mf_12)) 
                        iter1 = iter1.replace(/{{co_12}}/g, this.isNull(element.co_12))

                        iter1 = iter1.replace(/{{md_13}}/g, this.isNull(element.md_13)) 
                        iter1 = iter1.replace(/{{m2_13}}/g, this.isNull(element.m2_13)) 
                        iter1 = iter1.replace(/{{m3_13}}/g, this.isNull(element.m3_13)) 
                        iter1 = iter1.replace(/{{mf_13}}/g, this.isNull(element.mf_13)) 
                        iter1 = iter1.replace(/{{co_13}}/g, this.isNull(element.co_13))
                        }
                        this.html = this.html.replace(/{{disciplinas}}/g, disciplinasiter)
                        this.html = this.html.replace(/{{avaliacoes}}/g, avaliacoesiter)
                        this.html = this.html.replace(/{{dados}}/g, iter1)
     let options = { 'format': 'A3',
       'orientation': 'landscape',
       'border': {
                   'right': '10mm',
                   'left': '10mm' 
             },
       'header': {
         'height': '14mm' },
       'footer': {
         'height': '5mm'
       } }
       this.pautasgerarpdf(options)
     } catch (error) {
       Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao compor a pauta Anual' })
     }
    },


    isNull (notaPauta) {
      if (notaPauta) { return notaPauta } else return ''
    },
    async criarPdf (item) {
      this.isLoading = true
      const valor = {
        turma: item.pkTurma,
        ano: item.idAno_Academico
      }
      let camposPauta = {}
      try {
        this.disciplinas = await axios
          .post('/discipautageral', valor)
          .then(res => res.data)
        if (this.disciplinas.length > 0) this.disciplinas = this.disciplinas[0]
        if (this.disciplinas.length === 4) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            quant: 4
          }
        } else

        if (this.disciplinas.length === 6) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            quant: 6
          }
        } else
        if (this.disciplinas.length === 8) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            quant: 8
          }
        } else
        if (this.disciplinas.length === 9) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            quant: 9
          }
        } else
        if (this.disciplinas.length === 10) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            quant: 10
          }
        } else
        if (this.disciplinas.length === 11) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            quant: 11
          }
        } else
        if (this.disciplinas.length === 12) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            quant: 12
          }
        }else
        if (this.disciplinas.length === 13) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            d12: this.disciplinas[12].iddisciplina,
            quant: 12
          }
        }else
        if (this.disciplinas.length === 14) {
          camposPauta = {
            turma: this.disciplinas[0].pkTurma,
            ano: this.disciplinas[0].anoLectivo,
            d0: this.disciplinas[0].iddisciplina,
            d1: this.disciplinas[1].iddisciplina,
            d2: this.disciplinas[2].iddisciplina,
            d3: this.disciplinas[3].iddisciplina,
            d4: this.disciplinas[4].iddisciplina,
            d5: this.disciplinas[5].iddisciplina,
            d6: this.disciplinas[6].iddisciplina,
            d7: this.disciplinas[7].iddisciplina,
            d8: this.disciplinas[8].iddisciplina,
            d9: this.disciplinas[9].iddisciplina,
            d10: this.disciplinas[10].iddisciplina,
            d11: this.disciplinas[11].iddisciplina,
            d12: this.disciplinas[12].iddisciplina,
            d13: this.disciplinas[13].iddisciplina,
            quant: 12
          }
        }
        this.notas = await axios
          .post('/pautageral', camposPauta)
          .then(res => res.data)
        if (this.disciplinas.length === 4) { this.comporHtmlPauta4(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 6) { this.comporHtmlPauta6(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 8) { this.comporHtmlPauta8(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 9) { this.comporHtmlPauta9(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 10) { this.comporHtmlPauta10(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 11) { this.comporHtmlPauta11(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 12) { this.comporHtmlPauta12(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 13) { this.comporHtmlPauta13(this.disciplinas, this.notas) } else
        if (this.disciplinas.length === 14) { this.comporHtmlPauta14(this.disciplinas, this.notas) } 

      } catch (error) {
        this.isLoading = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar as disciplinas' })
      }
    },

     async carregarConfiguracoesReports () {
      try {
        let msg = await axios
          .post('/configuracoes', { empresa: 'report_Pauta' })
          .then(res => res.data)
        if (msg.length > 0) {
          this.configuracoesReport = msg
        }
      } catch (error) {

      }
    }
    }
}
</script>
